import React, { useState, useEffect, useRef, useContext } from "react";
import { ApiGetCall, ApiGetCallAuthKey } from "../../JS/Connector";
import { LogInUserID, formatDateToMMDDYYYY, customDates, userTimeZone, GetAllSchoolsByLocation } from "../../JS/Common";
import ReactDatePicker from "react-datepicker";
import TechnicianTable from "./AdminDashboardTables/TechnicianTable";
import SchoolTable from "./AdminDashboardTables/SchoolTable";
import IncomingDeviceTable from "./AdminDashboardTables/IncomingDeviceTable";
import OutgoingDeviceTable from "./AdminDashboardTables/OutgoingDeviceTable";
import MonthlyTicketComparison from "./AdminDashboardTables/MonthlyTicketComparison";
import { UserContext } from "../../App";
import TicketsPerRepair from "./AdminDashboardTables/TicketsPerRepair";
import { TicketByIssueGraph } from "./AdminDashboardTables/TicketByIssueGraph";
import TechniciansPerformance from "./AdminDashboardTables/TechniciansPerformance";
import DashboardBox from "./AdminDashboardTables/DashboardBox";
import TechnicianWeeklyReports from "./AdminDashboardTables/TechnicianWeeklyReports";
import CustomSVG from "../../Components/CustomSVG";
import { log } from "../../JS/Logger";
import { hasRoleAccess, RoleEnum } from "../../JS/RoleType";
import useConfig from "../../Hooks/useConfig";

export function Admindashboard() {
    const FilterRef = useRef(null);
    const DateRef = useRef(null);
    const { UserData } = useContext(UserContext);
    const { organization, school, adminCallNode } = useConfig();

    const today = new Date(
        new Date().toLocaleString("en-US", { timeZone: userTimeZone })
    );

    const oneMonthAgo = new Date(today);

    oneMonthAgo.setDate(1);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const day = today.getDate();

    const lastDayOfPreviousMonth = new Date(
        oneMonthAgo.getFullYear(),
        oneMonthAgo.getMonth() + 1,
        0
    ).getDate();

    oneMonthAgo.setDate(
        Math.min(day, lastDayOfPreviousMonth)
    );

    const [startDate, setStartDate] = useState(oneMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [Locations, setLocations] = useState([]);
    const [SchoolFilterData, setSchoolFilterData] = useState([]);
    const [AllSchool, setAllSchool] = useState([]);
    const [AllData, setAllData] = useState({
        kpidata: { data: [], loader: true },
        monthly_ticket_comparison: { data: [], loader: true },
        tickets_per_device: { data: [], loader: true },
        ticket_by_issue: { data: [], loader: true },
        technician_performance: { data: [], loader: true },
        incoming: { data: [], loader: true },
        outgoing: { data: [], loader: true },
        technician: { data: [], loader: true },
        schoolinvoice: { data: [], loader: true },
        technicianWeeklyReports: { data: [], loader: true },
    });
    const [LocationValue, setLocationValue] = useState(0);
    const [SchoolValue, setSchoolValue] = useState(0);
    const [ViewData, setViewData] = useState({
        actualData: { GraphData: [], TableData: [] },
        KPIView: {
            data: [],
            tab: "active"
        },
        TableView: {
            data: [],
            tab: ""
        },
        filterView: {
            DateName: "",
            DateView: false,
            sortView: false
        },
    });
    const [qflag, setQflag] = useState("1")

    useEffect(() => {
        var pageContentElement = document.querySelector('.page-content');
        pageContentElement.style.padding = '0rem';
        GetAllSchoolsByLocation({ setLocations, setSchoolFilterData, setAllSchool })
    }, []);
    const handleLocationValue = (val) => {
        setLocationValue(val);
        if (val == "0") {
            setSchoolFilterData(AllSchool)
        } else {
            var filterSchoolByLocation = Locations?.filter((data) => data?.id == val)
            setSchoolFilterData(filterSchoolByLocation[0]?.school?.slice()?.sort((a, b) => a.name.localeCompare(b.name)))
        }
    }

    function resetallfilter() {
        setStartDate(oneMonthAgo);
        setEndDate(today);
        setLocationValue(0);
        setSchoolValue(0);
        setQflag("1");
        setSchoolFilterData(AllSchool)
    }

    useEffect(() => {
        function handleClickOutside(ref, viewProperty) {
            return function (event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setViewData((prevState) => ({
                        ...prevState,
                        filterView: {
                            ...prevState?.filterView,
                            [viewProperty]: false
                        }
                    }));
                }
            }
        }

        const handleFilterClick = handleClickOutside(FilterRef, 'sortView');
        const handleDateClick = handleClickOutside(DateRef, 'DateView');

        document.addEventListener('mousedown', handleFilterClick);
        document.addEventListener('mousedown', handleDateClick);

        return () => {
            document.removeEventListener('mousedown', handleFilterClick);
            document.removeEventListener('mousedown', handleDateClick);
        };
    }, [FilterRef, DateRef, setViewData]);
    const [tabSwitch, setTabSwitch] = useState({ loadKPIData: 0, loadTableData: 0 })
    useEffect(() => {
        DateFilterHandel(qflag, startDate, endDate, LocationValue, SchoolValue)
    }, [ViewData?.KPIView?.tab])

    const DateFilterHandel = async (qflag, sdate, edate, locationid, schoolvalue, applyFilter = false) => {
        var loadKPIDataValue = tabSwitch?.loadKPIData
        var loadTableDataValue = tabSwitch?.loadTableData
        if (applyFilter) {
            loadKPIDataValue = 0
            loadTableDataValue = 0
        }
        if (locationid == 0) {
            locationid = null;
        }
        if (schoolvalue == 0) {
            schoolvalue = null;
        }
        if (loadKPIDataValue == 0 && ViewData?.KPIView?.tab == 'active') {
            var customStartDates = sdate;
            var customEndDates = edate;
            if (qflag != "1") {
                const { startDate, endDate } = customDates(parseInt(qflag));
                customStartDates = startDate;
                customEndDates = endDate;
            }
            setAllData((prevState) => ({
                ...prevState,
                kpidata: { ...prevState?.kpidata, loader: true },
                monthly_ticket_comparison: { ...prevState?.monthly_ticket_comparison, loader: true },
                tickets_per_device: { ...prevState?.tickets_per_device, loader: true },
                ticket_by_issue: { ...prevState?.ticket_by_issue, loader: true },
                technician_performance: { ...prevState?.technician_performance, loader: true },
            }));
            try {
                await fetchAdminData(`${adminCallNode}/dashboard/basic-details?startDate=${formatDateToMMDDYYYY(customStartDates)}&endDate=${formatDateToMMDDYYYY(customEndDates)}&userId=${LogInUserID}&schoolId=${schoolvalue}&locationId=${locationid}`, 'kpidata')
                await fetchAdminData(`${adminCallNode}/dashboard/monthly-comparison?startDate=${formatDateToMMDDYYYY(customStartDates)}&endDate=${formatDateToMMDDYYYY(customEndDates)}&schoolId=${schoolvalue}&locationId=${locationid}`, 'monthly_ticket_comparison')
                await fetchAdminData(`${adminCallNode}/dashboard/tickets-by-issue?startDate=${formatDateToMMDDYYYY(customStartDates)}&endDate=${formatDateToMMDDYYYY(customEndDates)}&schoolId=${schoolvalue}&locationId=${locationid}`, 'ticket_by_issue')
                await fetchAdminData(`${adminCallNode}/dashboard/tickets-per-device?startDate=${formatDateToMMDDYYYY(customStartDates)}&endDate=${formatDateToMMDDYYYY(customEndDates)}&schoolId=${schoolvalue}&locationId=${locationid}`, 'tickets_per_device')
                await fetchAdminData(`${adminCallNode}/dashboard/technician-performance-graph?startDate=${formatDateToMMDDYYYY(customStartDates)}&endDate=${formatDateToMMDDYYYY(customEndDates)}&locationId=${locationid}&schoolId=${schoolvalue}`, 'technician_performance')
            } catch (error) {
                log.error('An error occurred:', error);
            }
            loadKPIDataValue = 1
        }
        if (loadTableDataValue == 0 && ViewData?.TableView?.tab == 'active') {
            setAllData((prevState) => ({
                ...prevState,
                incoming: { ...prevState?.incoming, loader: true },
                outgoing: { ...prevState?.outgoing, loader: true },
                technician: { ...prevState?.technician, loader: true },
                schoolinvoice: { ...prevState?.schoolinvoice, loader: true },
                technicianWeeklyReports: { ...prevState?.technicianWeeklyReports, loader: true },
            }));
            try {
                await fetchAdminData(`${adminCallNode}/dashboard/incoming-devices?startDate=${formatDateToMMDDYYYY(sdate)}&endDate=${formatDateToMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolvalue}&page=1`, 'incoming')
                await fetchAdminData(`${adminCallNode}/dashboard/outgoing-devices?startDate=${formatDateToMMDDYYYY(sdate)}&endDate=${formatDateToMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolvalue}&page=1`, 'outgoing')
                await fetchAdminData(`${adminCallNode}/dashboard/technician-performance?startDate=${formatDateToMMDDYYYY(sdate)}&endDate=${formatDateToMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolvalue}&page=1`, 'technician')
                await fetchAdminData(`${adminCallNode}/dashboard/school-invoices?startDate=${formatDateToMMDDYYYY(sdate)}&endDate=${formatDateToMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolvalue}&page=1`, 'schoolinvoice')
                await fetchAdminData(`${adminCallNode}/dashboard/technician-performance-history?startDate=${formatDateToMMDDYYYY(sdate)}&endDate=${formatDateToMMDDYYYY(edate)}&locationId=${locationid}&schoolId=${schoolvalue}`, 'technicianWeeklyReports')
            } catch (error) {
                log.error('An error occurred:', error);
            }
            loadTableDataValue = 1
        }

        setTabSwitch({ loadKPIData: loadKPIDataValue, loadTableData: loadTableDataValue })

    };
    const fetchAdminData = async (endpoint, dataKey) => {
        try {
            const skipNormalize = dataKey === 'technicianWeeklyReports';
            const result = await ApiGetCall(endpoint, null, skipNormalize);

            if (result == undefined || result === "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                setAllData((prevState) => ({
                    ...prevState, // Ensure prevState is not undefined
                    [dataKey]: { ...prevState?.[dataKey], data: responseRs[dataKey], loader: false },
                }));
            }
        } catch (error) {
            setAllData((prevState) => ({
                ...prevState,
                [dataKey]: { ...prevState?.[dataKey], data: [], loader: false },
            }));
        }
    };
    return (
        <>
            <div className="" style={{ padding: "0 1.2rem 1.2rem 1.2rem" }}>
                <div className={` schoolDashboard pt-3`} >
                    <div className="row GridBox p-2 mx-0">
                        <div className="col-md-5 col-12 align-self-center pb-lg-0 pb-2"><h1 className="PageHeading mb-0">Dashboard</h1></div>
                        <div className="col-md-7 col-12">
                            <div className="row">
                                <div className="col-md-3 col-6 pb-lg-0 pb-2 mobile"></div>
                                <div className="col-md-3 col-6 pb-lg-0 pb-2">
                                    <div className="tabView p-2 cursor-pointer display-center" onClick={() => { setViewData((prevState) => ({ ...prevState, KPIView: { ...prevState?.KPIView, tab: "active" }, TableView: { ...prevState?.TableView, tab: "" } })) }}>
                                        <label className="pe-2"> <CustomSVG src={`/images/chartG.svg`} stroke={ViewData?.KPIView?.tab == "active" ? 'var(--primary-color)' : '#000'} /></label>
                                        <span style={{ color: ViewData?.KPIView?.tab == "active" ? "var(--primary-color)" : "#000", fontSize: "16px", fontWeight: "550" }}>Statistics</span>
                                    </div>
                                </div>
                                <div className="col-md-3 col-6 pb-lg-0 pb-2">
                                    <div className="tabView p-2 cursor-pointer display-center" onClick={() => { setViewData((prevState) => ({ ...prevState, KPIView: { ...prevState?.KPIView, tab: "" }, TableView: { ...prevState?.TableView, tab: "active" } })) }}>
                                        <label className="pe-2"> <CustomSVG src={`/images/tableG.svg`} stroke={ViewData?.TableView?.tab == "active" ? 'var(--primary-color)' : '#000'} /></label>
                                        <span style={{ color: ViewData?.TableView?.tab == "active" ? "var(--primary-color)" : "#000", fontSize: "16px", fontWeight: "550" }}>Tables</span>
                                    </div>
                                </div>
                                <><div className="col-md-3 col-6 pb-lg-0 pb-2 filter-dropdown " ref={FilterRef}>
                                    <div className="tabView p-2 cursor-pointer display-center " onClick={() => { setViewData((prevState) => ({ ...prevState, filterView: { ...prevState?.filterView, sortView: !prevState?.filterView?.sortView, } })) }}>
                                        <label className="pe-2"> <CustomSVG src={`/images/sortG.svg`} stroke={ViewData?.filterView?.sortView ? 'var(--primary-color)' : '#000'} /></label>
                                        <span style={{ color: ViewData?.filterView?.sortView ? "var(--primary-color)" : "#000", fontSize: "16px", fontWeight: "550" }}>Filter</span>
                                    </div>
                                    <div className={`admin-filter-dropdown-content greyBoxShadow p-2 ${ViewData?.filterView?.sortView ? "" : "d-none"} ${ViewData?.KPIView?.tab == 'active' && qflag == "1" ? "admin-KPI-active" : "admin-table-active"}`}>
                                        <div className="row">
                                            {ViewData?.KPIView?.tab == 'active' && <>
                                                <div className={`${qflag == "1" ? "col-md-2" : "col-md-3"} py-1`}>
                                                    <select value={qflag} onChange={(e) => { setQflag(e.target.value) }}>
                                                        <option value="1">Custom Date</option>
                                                        <option value="2">Current Month</option>
                                                        <option value="3">Current Quarter</option>
                                                        <option value="4">Current Year</option>
                                                        <option value="5">Last Month</option>
                                                        <option value="6">Last Quarter</option>
                                                        <option value="7">Last Year</option>
                                                    </select>
                                                </div>
                                            </>}

                                            {((ViewData?.KPIView?.tab == 'active' && qflag == "1") ||
                                                (ViewData?.TableView?.tab == 'active' && "1" == "1")) &&
                                                <>
                                                    <div className={`${ViewData?.KPIView?.tab == 'active' ? qflag == "1" ? "col-md-4" : "col-md-3" : "col-md-5"}`}>
                                                        <div className="row">
                                                            <div className="col-sm-5 pe-md-0 py-1">
                                                                <ReactDatePicker
                                                                    className="form-control text-center"
                                                                    selected={startDate}
                                                                    onChange={(e) => { setStartDate(e) }}
                                                                    dateFormat="MM/dd/yyyy"
                                                                />
                                                            </div>
                                                            <div className="col-sm-2 display-center px-0">
                                                                <label className="px-3">To</label>
                                                            </div>
                                                            <div className="col-sm-5 ps-md-0  py-1 ">

                                                                <ReactDatePicker
                                                                    className="form-control text-center"
                                                                    selected={endDate}
                                                                    onChange={(e) => { setEndDate(e) }}
                                                                    dateFormat="MM/dd/yyyy"
                                                                    maxDate={today}
                                                                    popperProps={{ strategy: 'fixed' }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </>}


                                            <div className={`${ViewData?.KPIView?.tab == 'active' ? qflag == "1" ? "col-md-4" : "col-md-6" : "col-md-5"}`}>
                                                <div className="row">
                                                    <div className="col-sm-6 py-1 pe-md-0">
                                                        <select value={LocationValue} onChange={(e) => { handleLocationValue(e.target.value) }}>
                                                            <option value="0">Filter by Location</option>
                                                            {Locations.map((locationItem, j) => (
                                                                <option value={locationItem.id} key={j}>
                                                                    {locationItem.location_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    <div className="col-sm-6 py-1 pe-md-0">
                                                        <select value={SchoolValue} onChange={(e) => { setSchoolValue(e.target.value) }}>
                                                            <option value="0">Filter by {organization}</option>
                                                            {SchoolFilterData?.length == 0 && <optgroup label={`No ${school} found`}></optgroup>}
                                                            {SchoolFilterData?.map((item, j) => (
                                                                <option value={item.id} key={j}>
                                                                    {item.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className={`${ViewData?.KPIView?.tab == 'active' ? qflag == "1" ? "col-md-2" : "col-md-3" : "col-md-2"} d-flex py-1 pe-md-4 align-items-center`}>
                                                <button className="btn btn-secondary w-100 filter-apply" onClick={() => {

                                                    setViewData(({ ...ViewData, filterView: { ...ViewData?.filterView, sortView: false } }));
                                                    DateFilterHandel(qflag, startDate, endDate, LocationValue, SchoolValue, true);
                                                }}>Apply</button>
                                                <div className="col-md-4 col-2 ps-2" title="Clear filter"><img className="img-fluid cursor-pointer" src="/images/clear-filter.svg" alt="" onClick={resetallfilter} /></div>
                                            </div>
                                        </div>
                                    </div>
                                </div></>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='GridBox px-3 mt-4' style={{ opacity: ViewData?.filterView?.DateView || ViewData?.filterView?.sortView ? "0.4" : "1", boxShadow: "none" }}>
                    {ViewData?.KPIView?.tab == "active" ? <>
                        <div className="row pt-4 pb-2 px-2 admin-dashboard-box-fonts">
                            <DashboardBox UserData={UserData} img={"admin-dashboard-icon-two.svg"} css={'admin-dashboard-box-two'} textcss={"boxone"} headers={`Total ${organization} registered`} AllData={AllData?.kpidata?.data?.school_account} loader={AllData?.kpidata?.loader} />
                            <DashboardBox UserData={UserData} img={"admin-dashboard-icon-one.svg"} css={'admin-dashboard-box-one'} textcss={"boxtwo"} headers={"Total devices registered"} AllData={AllData?.kpidata?.data?.register_devices} loader={AllData?.kpidata?.loader} />
                            <DashboardBox UserData={UserData} img={"admin-dashboard-icon-four.svg"} css={'admin-dashboard-box-four'} textcss={"boxthree"} headers={"Total tickets raised"} AllData={AllData?.kpidata?.data?.ticket_count} loader={AllData?.kpidata?.loader} />
                            <DashboardBox UserData={UserData} img={"admin-dashboard-icon-five.svg"} css={'admin-dashboard-box-five'} textcss={"boxfive"} headers={"Devices 7+ Days"} AllData={AllData?.kpidata?.data?.atvendor_count} loader={AllData?.kpidata?.loader} flag="1" CsvData={AllData?.kpidata?.data?.atvendor_data} />
                            {hasRoleAccess(UserData.copyrole || UserData.role || null, RoleEnum.TECH_POINT_BOX) ?
                                <DashboardBox UserData={UserData} img={"goal.svg"} css={'admin-dashboard-box-three'} textcss={"boxfour"} headers={"Your points"} AllData={AllData?.kpidata?.data?.technician_revenue} />
                                : null
                            }
                        </div>
                        <div className="row">
                            <MonthlyTicketComparison MonthlyTicketComparison={AllData?.monthly_ticket_comparison} />
                            <TicketsPerRepair TicketsPerDevice={AllData?.tickets_per_device} />
                            <TicketByIssueGraph TicketByIssue={AllData?.ticket_by_issue} />
                            <TechniciansPerformance TechnicianPerformance={AllData?.technician_performance} />
                        </div>
                    </> : <>
                        <div className="row py-3">
                            <IncomingDeviceTable startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} incomingData={AllData?.incoming} />
                            <OutgoingDeviceTable startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} outgoingData={AllData?.outgoing} />
                        </div>
                        <div className="row">
                            <TechnicianTable startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} technicianData={AllData?.technician} />
                            <SchoolTable startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} schoolinvoiceData={AllData?.schoolinvoice} />
                        </div>
                        <div className="row">
                            <TechnicianWeeklyReports startDate={startDate} endDate={endDate} LocationValue={LocationValue} SchoolValue={SchoolValue} technicianweeklyData={AllData?.technicianWeeklyReports} />
                        </div>
                    </>}
                </div >
            </div>
        </>
    )
}
